import {lightGray} from '@modifi/colors'
import {uploadFormComponents} from '@modifi/plugin-documents'
import styled from 'styled-components'

const FileUploadContainer = styled(uploadFormComponents.FileUploadContainer)`
  margin-bottom: 24px;
  border-bottom: 1px solid ${lightGray};
`

export default FileUploadContainer
